<template>
  <v-container>
    <canvas style="display:none" v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="768" :height="1024"></canvas>
    <v-row>

      <v-col cols="12">
        <v-btn style="float: left;     margin-top: 0px !important;"
          v-if="isCameraOpen && !$globalHandler.dialogLoader.visible" class="mt-n2" elevation="1" color="success"
          @click="takePhoto()">
          <v-icon style="margin-right: 10px; ">mdi-camera</v-icon>
          <span>{{ $t("upload_invoice") }}</span>
        </v-btn>
        <v-btn v-else style="float: left;     margin-top: 0px !important;" class="mt-n2" elevation="1" color="primary"
          @click="openCamera()">
          <v-icon style="margin-right: 10px">mdi-camera</v-icon>
          <span>{{ $t("turn_on_camera") }}</span>
        </v-btn>
        <v-file-input v-model="files" dense @change="onFileChange" color="primary" :placeholder="$t('select_document')"
          prepend-icon="mdi-paperclip" outlined accept="image/*, application/pdf" :display-size="1000" />
      </v-col>
      <v-col class="hidden-sm-and-down" cols="6">
        <video v-if="isCameraOpen" v-show="!isPhotoTaken" ref="camera" :width="768" :height="1024" autoplay></video>
        <div v-else>
          <v-card v-if="text">
            <v-card-title>Testo Riconosciuto</v-card-title>
            <v-card-text>
              <div style="max-height: 400px; overflow: auto;" v-html="text" v-on:mouseup="selectText($event)"></div>
            </v-card-text>
          </v-card>
          <embed style="width: 100%; height: auto" v-if="uploadedDoc" :src="uploadedDoc" :type="uploadedType" />
        </div>
      </v-col>
      <v-col md="6" cols="12">
        <v-row>
          <v-col cols="12">
            <v-select v-model="cge.cauId" :items="listCausali" :menu-props="{ maxHeight: '400' }"
              :label="$t('reg_causal')" required color="primary" persistent-hint></v-select>
          </v-col>
          <v-col cols="12">
            <v-select v-model="cge.cdc" item-value="cdxId" item-text="descr" :label="$t('cdc')" :placeholder="$t('cdc')"
              :items="listCdc" :menu-props="{ maxHeight: '400' }" persistent-hint></v-select>
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="cge.cassa" item-value="code" item-text="dex" :label="$t('select_account')"
              :placeholder="$t('select_account')" :items="listMastriNota" :menu-props="{ maxHeight: '400' }"
              persistent-hint></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="cge.numeDoc" prepend-icon="mdi-target" :outlined="picker === 'numeDoc' ? true : false"
              :class="
                picker === 'numeDoc'
                  ? 'v-input--is-focused success--text input-group--focused'
                  : ''
              " color="success" @click:prepend="picker = 'numeDoc'" :label="$t('reg_doc_number')"
              :placeholder="$t('reg_doc_number')" hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12">
            <my-datepicker v-model="cge.dateDoc" :label="$t('reg_doc_date')" prependIcon="mdi-target"
              :outlined="picker === 'dateDoc' ? true : false" :classe="
                picker === 'dateDoc'
                  ? 'v-input--is-focused success--text input-group--focused'
                  : ''
              " @clickPrepend="setPicker('dateDoc')" :placeholder="$t('reg_doc_date')" />
          </v-col>
          <v-col cols="12">
            <my-datepicker v-model="cge.datePag" :label="$t('reg_pag_date')" prependIcon="mdi-target"
              :outlined="picker === 'datePag' ? true : false" :classe="
                picker === 'datePag'
                  ? 'v-input--is-focused success--text input-group--focused'
                  : ''
              " @clickPrepend="setPicker('datePag')" :placeholder="$t('reg_pag_date')" />
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="cge.text" prepend-icon="mdi-target" :outlined="picker === 'text' ? true : false"
              :class="
                picker === 'text'
                  ? 'v-input--is-focused success--text input-group--focused'
                  : ''
              " @click:prepend="picker = 'text'" :label="$t('text')" :placeholder="$t('text')"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="cge.supplier" item-value="code" item-text="dex" prepend-icon="mdi-target"
              :outlined="picker === 'supplier' ? true : false" :class="
                picker === 'supplier'
                  ? 'v-input--is-focused success--text input-group--focused'
                  : ''
              " @click:prepend="picker = 'supplier'" :label="$t('supplier')" :placeholder="$t('supplier')"
              :items="listMastriFornitori" :menu-props="{ maxHeight: '400' }" @change="updateLine(dettaglio)"
              persistent-hint></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="cge.importo" prepend-icon="mdi-target" :outlined="picker === 'importo' ? true : false"
              :class="
                picker === 'importo'
                  ? 'v-input--is-focused success--text input-group--focused'
                  : ''
              " @click:prepend="picker = 'importo'" :label="$t('reg_value')" :placeholder="$t('reg_value')"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn class="mx-5" @click="saveCge" color="success">{{
              $t("save")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "upload-fattura",
  components: { MyDatepicker },
  props: {},
  data() {
    return {
      files: [],
      fileName: null,
      picker: null,
      listMastriFornitori: [],
      listMastriNota: [],
      listCdc: [],
      listCausali: [],
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      arrPicker: [
        "numeDoc",
        "dateDoc",
        "datePag",
        "text",
        "supplier",
        "importo",
      ],
      cge: {
        cauId: null,
        cdcId: null,
        supplier: null,
        numeDoc: null,
        dateDoc: null,
        datePag: null,
        cassa: null,
        text: null,
        importo: null,
      },
      uploadedDoc: null,
      uploadedType: null,
      text: null,
      isFetching: true,
    };
  },
  watch: {
    uploadedDoc: function (newVal, oldVal) {
      let _ = this;
      _.cge = {
        cauId: null,
        cdcId: null,
        supplier: null,
        numeDoc: null,
        dateDoc: null,
        datePag: null,
        cassa: null,
        text: null,
        importo: null,
      };
      // watch it
      if (newVal) {
        _.chiamataAxios("POST", "/auth/contab/ocrCreateCge", {
          dialogLoader: true,
          body: { docData: newVal },
        }).then((response) => {
          _.text = response.data.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
          _.cge = response.data.cge;
          _.picker = _.getNextPicker();
        });
      }
    },
  },
  methods: {
    openCamera() {
      this.isCameraOpen = true;
      this.createCameraElement();
    },

    createCameraElement() {
      this.$globalHandler.dialogLoader.visible = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$globalHandler.dialogLoader.visible = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.$globalHandler.dialogLoader.visible = false;
          alert("May the browser didn't support or there is some errors.");
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;
      const canvas = this.$refs.canvas;

      canvas
        .getContext("2d")
        .drawImage(this.$refs.camera, 0, 0, canvas.width, canvas.height);

      let image = canvas.toDataURL();
      this.isCameraOpen = false;
      this.isPhotoTaken = false;
      this.isShotPhoto = false;
      this.stopCameraStream();
      this.uploadedDoc = image;
      this.uploadedType = "image/jpg";
    },
    setPicker(value) {
      this.picker = value;
    },
    getNextPicker() {
      let _ = this;
      let index = null;
      for (
        let x = _.arrPicker.indexOf(_.picker) + 1;
        x < _.arrPicker.length;
        x++
      ) {
        if (!_.cge[_.arrPicker[x]] || _.cge[_.arrPicker[x]] === "") {
          index = x;
          break;
        }
      }
      if (index !== null && index < _.arrPicker.length)
        return _.arrPicker[index];
      else return null;
    },
    selectText(event) {
      let text = "";
      let _ = this;
      if (window.getSelection) {
        text = window.getSelection().toString();
      } else if (document.selection && document.selection.type != "Control") {
        text = document.selection.createRange().text;
      }
      if (text !== "") {
        // Controlli validità
        let parsedDate = null;
        let max = new Date();
        let min = new Date();
        min.setFullYear(min.getFullYear() - 1);
        switch (_.picker) {
          case "datePag":
            parsedDate = _.parseDate(_.cge[_.picker], min, max);
            if (parsedDate) _.cge[_.picker] = parsedDate;
            else _.cge[_.picker] = null;
            break;
          case "dateDoc":
            parsedDate = _.parseDate(_.cge[_.picker], min, max);
            if (parsedDate) _.cge[_.picker] = parsedDate;
            else _.cge[_.picker] = null;
            break;
          default:
            _.cge[_.picker] = text;
        }

        _.picker = _.getNextPicker();
      }
    },
    onUpload() {
      console.log(this.file);
    },
    onFileChange(e) {
      let _ = this;
      let file = _.files;
      if (!file) return;
      this.fileName = file.name;
      let reader = new FileReader();
      reader.onload = (e) => {
        _.uploadedDoc = e.target.result;
        _.uploadedType = file.type;
      };
      reader.readAsDataURL(file);
    },
    saveCge: function () {
      let _ = this;
      // Prepara richiesta
      let objReg = {
        cauId: _.cge.cauId,
        date: _.cge.datePag,
        dateDoc: _.cge.dateDoc,
        numeDoc: _.cge.numeDoc,
        text: _.cge.text,
        type: "U",
        allegati: [{ newName: _.fileName, base64: _.uploadedDoc }],
        dettagli: [
          { line: 1, cdxId: 0, importo: _.cge.importo, code: _.cge.supplier },
          {
            line: 2,
            cdxId: _.cge.cdcId,
            importo: 0 - _.cge.importo,
            code: _.cge.cassa,
          },
        ],
      };
      _.chiamataAxios("PUT", "/auth/contab/createCge", {
        dialogLoader: true,
        body: objReg,
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          if (screen.width > 648) _.$emit("isUpdated", "true");
          else _.$router.push("/portal/contab/dashboard");
        }
      });
    },
  },
  created() {
    let _ = this;
    _.listMastriNota = [];
    _.listMastriFornitori = [];
    _.listCdc = [];
    _.listCausali = [];
    this.chiamataAxios("GET", "/auth/contab/listCausali").then((response) => {
      _.listCausali = response.data.map(function (item) {
        return { value: item.cauId, text: item.descr };
      });
    });
    _.chiamataAxios("GET", "/auth/contab/listMastriFornitori").then(
      (response) => {
        _.listMastriFornitori = response.data;
      }
    );
    _.chiamataAxios("GET", "/auth/contab/listMastriNota").then((response) => {
      _.listMastriNota = response.data;
    });
    _.chiamataAxios("GET", "/auth/contab/listCdx").then((response) => {
      _.listCdc = response.data.cdc;
    });
  },
};
</script>
